export default "__VITE_ASSET__b4nKniS6__"